export const GET_PERSON = "PERSON_REDUCER_GET_PERSON";
export const GET_PERSON_DOGS = "PERSON_REDUCER_GET_PERSON_DOGS";
